/**
 * Module dependencies.
 */

import { CrudEdit } from 'app/components/organisms/crud/crud-edit';
import { CrudTemplate } from 'app/components/organisms/crud/form-types';
import { apiEndpoints } from 'app/core/config/api-endpoints';
import { resolveAppPath } from 'app/core/utils/url-resolver';
import { appRoutes } from 'app/routes';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { saleFormConfig } from './sales-items/form-sale-config';
import moment from 'moment';
import { Title } from 'app/components/atoms/title/title';
import { Sale } from 'app/types/sale';

/**
 * Export `SaleEdit` component.
 */

export function SaleEdit(): JSX.Element {
  const [translate] = useTranslation();
  const { userId } = useParams();
  const template = useMemo((): CrudTemplate<Sale> => {
    return {
      list: {
        endpointById: apiEndpoints.userSalesById
      } as any,
      edit: {
        formFields: saleFormConfig(translate),
        languages: ['*'],
        submitLabel: translate('common.actions.add'),
        normalizePayload: payload => {
          const cleanPayload = JSON.parse(JSON.stringify(payload));

          cleanPayload.createdAt = moment().toISOString();

          for (const item of cleanPayload.lines ?? []) {
            item.quantity = parseInt(item.quantity, 10);
          }

          if (!cleanPayload.integrationId) {
            delete cleanPayload.integrationId;
          }

          delete cleanPayload.id;
          delete cleanPayload.pharmacy;
          delete cleanPayload.userId;
          delete cleanPayload.integrationCreatedAt;
          delete cleanPayload.updatedAt;
          delete cleanPayload.createdAt;
          delete cleanPayload.deletedAt;
          delete cleanPayload.externalOrderNumber;

          for (const item of cleanPayload.lines ?? []) {
            delete item.saleId;
            delete item.createdAt;
            delete item.updatedAt;
            delete item.deletedAt;
            delete item.posologyId;

            for (const it of item.posology ?? []) {
              delete it.itemId;
              delete it.productId;
              delete it.productCode;
              delete it.productName;
              delete it.createdAt;
              delete it.updatedAt;
              delete it.metadata;

              for (const dos of it.dosage ?? []) {
                delete dos.posologyId;
                delete dos.createdAt;
                delete dos.updatedAt;
                delete dos.dosageIteration;
              }
            }
          }

          console.log(cleanPayload);

          return cleanPayload;
        },
        normalizeInitialValues: (keys, values) => {
          return values;
        },
        redirect: resolveAppPath(appRoutes.dashboard.users.detail.sales, { userId }),
        endpoint: apiEndpoints.userSalesEdit
      }
    };
  }, [translate, userId]);

  return (
    <>
      <Title>{translate('users.sales.edit.title')}</Title>

      <CrudEdit template={template} />
    </>
  );
}
